import { render } from "./SearchComponent.vue?vue&type=template&id=b4e15a80"
import script from "./SearchComponent.vue?vue&type=script&lang=js"
export * from "./SearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akhenry/Code/openmct-clean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__